<template>
  <div class="OrderManageList-root">
    <div v-if="isSearch" class="search-pane">
      <pro-search
        :fileds="SearchFiled"
        :form="queryForm"
        @search="handleSearch"
        @reset="handleReset"
      />
    </div>

    <div class="table-content">
      <div class="operate-bar">
        <a-button class="export_btn" @click="handleExport">批量导出账单</a-button>
      </div>
      <a-table
          :columns="tableColumns"
          :data-source="orderData"
          row-key="id"
          :loading="tableLoading"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :scroll="{ x: 'calc(700px + 50%)'}"
          :pagination="pagination"
          @change="handleTableChange"
      >
        <template slot="billCode" slot-scope="text,row">
          <span class="details">
             <a @click="checkDetail(row)">{{ text }}</a>
          </span>
        </template>
        <template slot="billStatus" slot-scope="text">
          <span class="status" :style="`--color:${BILL_STATUS_TEXT_COLOR[text]}`">{{BILL_STATUS_TEXT[text]}}</span>
        </template>
        <template slot="billName" slot-scope="text">
          <a-tooltip v-if="text.length>20" placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span>{{ conductLength(text) }}</span>
          </a-tooltip>
          <span v-else>{{ conductLength(text) }}</span>
        </template>
        <template slot="outCustomerName" slot-scope="text">{{ text || '--' }}</template>
        <template slot="createTime" slot-scope="text">{{ tranTime(text) }}</template>
        <!-- 操作栏 -->
        <span slot="action" slot-scope="text,row">
          <template  v-if="row.billStatus === BILL_STATUS.BILL_RECONCILIATION">
            <a class="action-btn" type="link" @click="handleConfirmBill(row)">确认账单</a>
            <a class="action-btn" type="link" @click="handleBackBill(row)">退回账单</a>
          </template>
          <span v-else>--</span>
        </span>
      </a-table>
    </div>
    <backBillDialog ref="backBillDialog" @refresh="handleRefresh" />
  </div>
</template>

<script>
import moment from 'moment'
import {formatNullData, moneyFormat} from '@/utils/util'
import ProSearch from '@/components/TableSearch/index.vue'
import {EventBus} from '@/utils/event-bus'
import {getBillList,checkBill,billDownloadExcel} from "@/api/bill";
import {tableColumns, BILL_MONTH, BILL_MONTH_C0MP, BILL_STATUS, SearchFiled,BILL_STATUS_TEXT,BILL_STATUS_TEXT_COLOR} from './constant.js'
// import {customerBillExport} from '../overview/api'
import backBillDialog from './components/backBillDialog.vue'

export default {
  name: 'OnLineBill',
  components: {
    ProSearch,
    backBillDialog,
  },
  data() {
    return {
      tableColumns,
      BILL_STATUS_TEXT_COLOR,
      BILL_STATUS_TEXT,
      openMore: false,
      SearchFiled,
      BILL_STATUS,
      BILL_MONTH,
      BILL_MONTH_C0MP,
      orderData: [],
      selectedRowKeys: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
        },
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      queryForm: {},
      isSearch:true,
      tableLoading:false,
    }
  },
  computed: {
    tranTime() {
      return (time) => moment(time).format('YYYY-MM-DD')
    },
    conductLength() {
      return (text) => {
        return text.length > 20 ? `${text.substring(0, 19)}...` : text
      }

    },
  },
  created() {
    this.setInitData()
  },
  beforeRouteEnter(to, from, next) {
    next(mv => {
      const forms = from
      if (forms.path !== '/data/onLineBill/billDetails') {
        mv.isSearch = false;
        setTimeout(()=>{
          mv.isSearch = true;
        },50)
        mv.setInitData()
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    setInitData(){
      const {creditCode} = this.$store.state.user
      if (!creditCode) {
        this.SearchFiled = this.SearchFiled.filter(item => item.name !== 'customerCode')
        this.getData()
      }
    },
    checkDetail(row) {
      this.$router.push({path: `/data/onLineBill/billDetails`,query:{billId:row.id,billCode:row.billCode}})
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.getData();
    },
    async handleExport() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择需要导出的账单')
        return
      }
      const {creditCode,customerName,customerCode,accountName,realName} = this.$store.state.user;
      await billDownloadExcel({
        ids: this.selectedRowKeys,
        billType:'TRANSPORT',
        type: "payer",
        exportCustomerCode:customerCode,
        payerTenantId:customerCode,
        exportCustomerName:creditCode?customerName:accountName,
        createUserName:realName
      })
      EventBus.$emit('taskPopover')
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleChange(value) {
      this.queryForm.invoiceStatus = [value]
    },
    async getData() {
      this.tableLoading = true;
      this.queryForm = formatNullData(this.queryForm)
      const params = {
        size: this.pagination.pageSize,
        page: this.pagination.current
      }
      const {createTime = [],billCode,...restParams}  = this.queryForm;
      const [beginTime,endTime]  =createTime;
      const data = {
        ...restParams,
        billCodes:billCode?[billCode]:undefined,
        billStatuses: [],
        beginTime:beginTime?moment(beginTime).format('YYYY-MM-DD HH:mm:ss'):undefined,
        endTime:endTime?moment(endTime).format('YYYY-MM-DD HH:mm:ss'):undefined,
        billType: "TRANSPORT",
        payerTenantId: this.$store.state.user.customerCode,
        type: "payer",
        ...params
      }
      try {
        const res = await getBillList(data)
        res.records.forEach((item)=>{
          item.createTime = moment(item.createTime).format('YYYY-MM-DD');
          item.billMoneyTaxFormat = moneyFormat(item.billMoneyTax)
        })
        this.orderData = res.records
        this.pagination.total = res.total
        this.tableLoading = false;
      } catch (error) {
        this.tableLoading = false;
      }
    },
    handleSearch(form) {
      this.pagination.current = 1
      this.queryForm = {
        ...form,
      }
      this.getData();
    },
    handleReset() {
      this.queryForm = {}
      this.getData();
    },
    handleConfirmBill(row){
      // 确认账单
      this.$confirm({
        title: '确认账单',
        content: `账单金额${row.billMoneyTaxFormat||'-'}元`,
        okText:'确定',
        cancelText:'取消',
        class:'bill_confirm_model',
        onOk:async()=> {
          const {id,billCode} = row;
          await checkBill({moneyTax:row.billMoneyTax,billId:id,billCode,voucherDate:moment().format('YYYY-MM-DD')})
          this.$message.success('确认账单成功!')
          this.handleRefresh()
        },
      });
    },
    handleBackBill(row){
      // 退回账单
      this.$refs.backBillDialog.show(row)
    },
    handleRefresh(){
      this.getData();
    }
  }
}
</script>

<style lang="less" scoped>
.table-content {
  padding: 24px;
  background-color: #fff;
  border-radius: 6px;
}

.search-pane {
  padding: 24px;
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

.search-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.moreData {
  height: 30px;
  line-height: 50px;
  background-color: #fff;
  font-size: 12px;

  &:hover {
    cursor: pointer;
   
  }
}

.nextForm {
  margin-top: 15px;
  transition: all ease .2s;
}

.nextFormActive {
  height: auto;
}

.form-row {
  .formTitle {
    text-align: right;
    padding-right: 6px;
    width: 100%;
    display: inline-block;
    font-size: 0.8rem;
    line-height: 32px;
  }
}

.form-item:last-child {
  margin-right: 0;
}

.w-224 {
  min-width: 150px;
}

.form-btns {
  display: flex;
  justify-content: flex-end;
  margin-right: 0;
  margin-top: 10px;
}

.form-btn {
  margin-left: 20px;
}

.line-item {
  margin-bottom: 15px;
}

.operate-bar {
  text-align: left;
  margin-bottom: 20px;

  .ant-btn-text {
    color: #06B880;
  }
}

.details {
  color: #06B880;
  text-decoration: underline;
}

.beyond {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.pagination
:global(.ant-pagination-item-active .ant-pagination-item-active:focus) {
  background: #06b880;
}

/deep/ .ant-pagination {
  .ant-pagination-item {
    // background-color: transparent;
    border: 1px solid transparent;
    margin-left: 5px !important;
  }

  .ant-pagination-item-active {
    background: #06b880;
  }

  .ant-pagination-prev .ant-pagination-item-link {
    background-color: #F6F8FA !important;
    border: 1px solid transparent;

    &:hover {
      background-color: #E6EAF4 !important;
    }
  }

  .ant-pagination-next .ant-pagination-item-link {
    background-color: #F6F8FA !important;
    border: 1px solid transparent;

    &:hover {
      background-color: #E6EAF4 !important;
    }
  }

  .ant-pagination-options-quick-jumper input {
    background-color: #F6F8FA !important;
    border: 1px solid transparent;
  }

  .ant-select-selection {
    background-color: #F6F8FA !important;
  }

  .ant-pagination-item-active a {
    color: #fff;
  }
}

.export_btn {
  color: #06B880;
  border-color: #06B880;

  &:hover {
    color: #68D2B1;
    border-color: #68D2B1;
  }

  &:active {
    color: #059C6C;
    border-color: #059C6C;
  }
}
.action-btn{
  margin-right: 8px;
}
.status{
  display: flex;
  align-items: center;
  &::before{
    content: '';
    width: 6px;
    height: 6px;
    background: var(--color);
    display: inline-block;
    margin-right: 8px;
    border-radius: 50%;
  }
}
</style>
<style lang="less">
.bill_confirm_model{
  .ant-modal{
    top: calc(50% - 90px);
  }
}

</style>